import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { onMounted, ref, inject, watch } from 'vue';
import { useRouter, useRoute, onBeforeRouteUpdate } from 'vue-router';
import { Auth, Hub, DataStore, syncExpression } from 'aws-amplify';
import { Member, Shop } from './models';
import Loading from './components/PageLoading.vue'

import { useCookies } from 'vue3-cookies';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter();
const route = useRoute();

const {cookies} = useCookies();

const member = ref<Member>();
const shop = ref<Shop>();
const user = ref();

const loading = ref(true);
const mounted = ref(false);

const authCheck = async() => {
  try {
    console.log(location.pathname);

    let shopId: any = null;

    const buf = (await DataStore.query(Member, (m) => m.cogUser('eq', user.value.username)));
    if(location.pathname.match(/registration/)) {
      if (buf.length > 0) {
        router.push('/');
      }
    }
    else if(buf.length <= 0) {
      router.push('/registration/mail');
    }
    else {
      if (buf[0].paymentMethod == null) {
        member.value =  await DataStore.save(Member.copyOf(buf[0], (updated) => {
          updated.paymentMethod = 1;
        }));
      }
      else {
        member.value = buf[0];
      }
      console.log(member.value);
      shopId = member.value.shopID
      console.log('shopid', shopId);
    }

    document.title = '-';

    if (shopId) {
      shop.value = (await DataStore.query(Shop, (s) => s.id('eq', shopId)))[0];
      console.log('shop');
      console.log(shop.value);
      document.title = shop.value.name!;
    }
  }
  catch(e) {
    console.log('Auth failed');
    console.log(e);
    router.push('/login');
  }
}

onMounted(async() => {
  document.body.oncontextmenu = function () {return false;}

  addEventListener("popstate", () => {
    router.push("/")
  })
});

watch(route, async() => {
  loading.value = true;

  console.log(route.name);

  if (location.pathname == '/login' || 
      location.pathname == '/login-progress' || 
      location.pathname == '/debug' ||
      location.pathname == '/iftest') {
    return;
  }
  
  try {
    user.value = await Auth.currentAuthenticatedUser();
    console.log(user.value);
    if (!user.value) {
      router.push('/login');
      return;
    }
  }
  catch(e) {
    router.push('/login');
    return;
  }

  await authCheck();
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["root", {'loading' : loading.value}])
    }, [
      _createVNode(_component_router_view, {
        member: member.value,
        shop: shop.value,
        loading: loading.value,
        onStopLoading: _cache[0] || (_cache[0] = ($event: any) => (loading.value = false)),
        onStartLoading: _cache[1] || (_cache[1] = ($event: any) => (loading.value = true))
      }, null, 8, ["member", "shop", "loading"])
    ], 2),
    (loading.value)
      ? (_openBlock(), _createBlock(Loading, { key: 0 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})